module.exports = __webpack_public_path__ + "static/media/Dr Evren Tok.4774cbd1.jpg";